import { z } from 'zod';
import { optionalTrimmedNullableString, optionalUuidString } from '../zod-helpers/index.js';
import { CAL_EVENT_VENUE_LIMITS } from './cal-event-venue-limits.js';
export const venueAddressSchema = z.object({
    addressName: z
        .string()
        .trim()
        .max(CAL_EVENT_VENUE_LIMITS.name, `Venue name must be ${CAL_EVENT_VENUE_LIMITS.name} characters or fewer.`)
        .optional()
        .nullable(),
    address: z
        .string()
        .trim()
        .max(CAL_EVENT_VENUE_LIMITS.address, `Address must be ${CAL_EVENT_VENUE_LIMITS.address} characters or fewer.`)
        .optional()
        .nullable(),
    city: optionalTrimmedNullableString(CAL_EVENT_VENUE_LIMITS.city, `City must be ${CAL_EVENT_VENUE_LIMITS.city} characters or fewer.`),
    zip: optionalTrimmedNullableString(CAL_EVENT_VENUE_LIMITS.zip, `Zip must be ${CAL_EVENT_VENUE_LIMITS.zip} characters or fewer.`),
    stateId: optionalUuidString('Invalid state.').optional().nullable(),
    countryId: optionalUuidString('Invalid country.').optional().nullable(),
});
//# sourceMappingURL=venue-address-schema.js.map